// extracted by css-extract-rspack-plugin
export default {"button":"ColumnInput-module__button___Z3EV7","root":"ColumnInput-module__root___dazIA","open":"ColumnInput-module__open___edmjL"};